import React from 'react';
import PropTypes from 'prop-types';
import { actions } from 'actions';
import { connect } from 'unistore/preact';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/bot/HoneyPot.scss';

const HoneyPot = ({ onHPTriggered }) => {

  const onHPClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    return onHPTriggered();
  };

  //`hide` exists as style, but naming differently to attempt obfuscation from bot
  return (
    <div className="csw-hp">
      <button className="csw-hp-btn" type="submit" onClick={onHPClick}
              aria-label="Please ignore this" tabIndex={-1}>Submit</button>
    </div>
  );
};

HoneyPot.propTypes /* remove-proptypes */ = {
  id: PropTypes.string,
  onHPTriggered: PropTypes.func.isRequired,
};

export default connect('', actions)(HoneyPot);
